import { useLocalization } from '../../../lib/hooks/useLocalization';
import { AppImage } from '../../AppImage';

export function NextIcon({ type }) {
  const { nextAlt } = useLocalization().translations.unique.components.datePicker;
  return <AppImage src='/icons/chevron-right.svg' alt={nextAlt({ type })} />;
}
